import styled from "styled-components";

export const TabContainer = styled.div`
  display: flex;
  align-items: end;
  padding: 0 2rem;
  border-bottom: 1px solid #eeeeee;
  background-color: white;
`;
